define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StyleTool = void 0;
    class StyleTool {
        constructor(viewer, id, defaultValue, changeHandler) {
            this.id = id;
            this.viewer = viewer;
            this.changeHandler = changeHandler;
            this.defaultValue = defaultValue;
            // @ts-ignore
            this.btnElement = this.container;
            this.title = id.replace('-', ' ');
        }
        initTool() { }
        getTitle() {
            return this.title;
        }
    }
    exports.StyleTool = StyleTool;
});
//# sourceMappingURL=StyleTool.js.map